module.exports = __webpack_public_path__ + "img/framboise_shell_cooked_closeup.84f5da59.jpg";